
<!-- Modal -->
<div class="modal fade" *ngIf="webApi.isLoggedIn()" id="suggest-skill" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      <form class="signup-form" [formGroup]="skillForm" (ngSubmit)="onSubmitSkill(skillForm)">
        <div class="modal-body">
          
          <h5 class="mb-4">Suggest a Skill</h5>
          <p>Want to see something specific?  Let us know what new content you want us to add to the Forge.  
            Be sure to include specifics (Level, Rulebook, Skill Type).  We will be sure to incorporate all requests in our future filming.</p>
            <!-- <div class="form-group">
                <label for="emailInput" class="form-label">Your Email address</label>
                <input type="email" class="form-control" formControlName="email" id="emailInput">
                <div class="invalid-feedback d-block"
                    *ngIf="(f2['email'].errors?.['required'] || f2['email'].errors?.['email']) && (f2['email'].dirty || f2['email'].touched)">
                    Please fill valid email.
                </div>
            </div>
            <div class="form-group">
                <label for="" class="form-label">Name:</label>
                <input type="text" class="form-control" formControlName="name">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['name'].errors?.['required'] && (f2['name'].dirty || f2['name'].touched)">
                    Please fill name.
                </div>
            </div>
            <div class="form-group">
                <label for="" class="form-label">Profession:</label>
                <input type="text" class="form-control" formControlName="profession">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['profession'].errors?.['required'] && (f2['profession'].dirty || f2['profession'].touched)">
                    Please fill profession.
                </div>
            </div> -->
            <div class="form-group">
                <label for="" class="form-label">Message:</label>
                <textarea type="text" class="form-control" formControlName="message"></textarea>
                <div class="invalid-feedback d-block"
                    *ngIf="f2['message'].errors?.['required'] && (f2['message'].dirty || f2['message'].touched)">
                    Please write a message.
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-gold">Submit <i *ngIf="skillSubmitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>